import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// --------------------------------------------------
// Determine Device Size
// --------------------------------------------------
const mobileMediaQuery = window.matchMedia("(max-width: 1200px)");
let isMobile = mobileMediaQuery.matches;
const handleMobileChange = (e) => {
  isMobile = e.matches;
  const sidebar = document.querySelector("aside");
  if (sidebar) {
    if (!isMobile) {
      sidebar.classList.remove("-translate-x-full");
    } else {
      sidebar.classList.add("-translate-x-full");
    }
  }
};
mobileMediaQuery.addEventListener("change", handleMobileChange);
handleMobileChange(mobileMediaQuery);

// --------------------------------------------------
// DOM Loaded
// --------------------------------------------------
document.addEventListener("DOMContentLoaded", (event) => {
  
  // add # before titles
  document.querySelectorAll("h2").forEach((heading) => {
    const hashSpan = document.createElement("span");
    hashSpan.className = "mr-2 text-white/25 inline-block select-none";
    hashSpan.textContent = "#";
    heading.prepend(hashSpan);
  });

  const sidebar = document.querySelector("aside");
  // const triggerBtn = document.querySelector("#trigger");

  // --- 1. SETUP: Inject Icons & Apply Flex Layout ---
  sidebar.querySelectorAll("li").forEach((li) => {
    const childUl = li.querySelector(":scope > ul");
    if (childUl) {
      const link = li.querySelector(":scope > a");
      link.classList.add("flex", "items-center", "justify-between", "w-full");
      const span = document.createElement("span");
      span.className = "toggle-icon ml-2";
      span.textContent = "+";
      link.appendChild(span);
      li.classList.add("collapsed");
    }
  });

  // Select all links that act as dropdown toggles
  const menuToggles = document.querySelectorAll("aside a.flex");
  menuToggles.forEach((toggle) => {
    toggle.addEventListener("click", (e) => {
      e.preventDefault();
      const parentLi = toggle.closest("li");
      const subMenu = parentLi.querySelector("ul");
      const icon = toggle.querySelector(".toggle-icon");
      if (subMenu) {
        subMenu.classList.toggle("hidden");
      }
      parentLi.classList.toggle("collapsed");
    });
  });
});
